/* Import Section - Start */

/* React Imports - Start */

import React, { forwardRef, useEffect, useState } from "react";

/* React Imports - End */

/* Plugin Imports - Start */

import { MultiSelect } from "primereact/multiselect";
import { useIsEdited } from "../../Providers/IsEditedProvider"

/* Plugin Imports - End */

/* Import Section - End */

/* Function - Start */

const MultiSelectElement = forwardRef((props,ref) => {
  /* State Declaration - Start */

  /* useState - Start */
  const [selectedValue, setSelectedValue] = useState(props.value);
  const { setIsEdited } = useIsEdited();

  /* useState - End */

  /* useEffect - Start */

  useEffect(() => {
    if (props.value) {
      setSelectedValue(props.value);
    } else {
      setSelectedValue(null);
    }
  }, [props.value]);

  /* useEffect - End */

  /* State Declaration - End */

  /* Methods - Start */

  const onValueChange = (e) => {
    setIsEdited(true);
    setSelectedValue(e.value);
    props.onChangeValue(e);
  };

  /* Methods - End */

  /* Render View Return - Start */

  return (
    <div className="flex align-center selecting-dropdown">
      <h5 className="dropdown-heading">{props.dropdownName}</h5>
      <MultiSelect
        name={props.name}
        id={props.id}
        value={selectedValue}
        options={props.options}
        onChange={(e) => onValueChange(e)}
        optionLabel={props.optionLabel}
        ref={ref}
        filter
        showClear={props.showClear}
        // filterBy="name"
        placeholder={props.placeholder}
        className={`custom-multiselect ${props.className}`} // Apply the custom class
        disabled={props.disabled}
        maxSelectedLabels={props.maxSelectedLabels}
        register={props.register}
        style={{ paddingLeft: "10px" }}
        showSelectAll={props.showSelectAll}
      />
    </div>
  );

  /* Render View Return - End */
});

/* Function - End */

/* Export default functionName; */

export default MultiSelectElement;
